const isImage = (file: { name?: string; type?: string; mimeType?: string }) => {
  const fileFormat = file.name?.split('.').pop()?.toLowerCase() || '';
  const fileType = file.mimeType || file.type || '';
  const mimeType = fileType.toLowerCase() || fileFormat;

  return fileType.includes('image') || mimeType.includes('heic') || mimeType.includes('heif');
};

export default isImage;
